import React, { useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaTimes } from "react-icons/fa";
import { FaVideo } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { video_modal } from "../../Pages/actions/video_audio_modal";
import socketModel from "../../models/socketModel";
import { useNavigate } from "react-router-dom";
import methodModel from "../../methods/methods";
const VideoCallRingModal = ({ isOpen, setIsOpen, roomId, CallingUserData = {} }) => {
    const [RoomDetails, setRoomDetails] = useState({})
    const history = useNavigate()
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const chats = useSelector((state) => state.chats?.data)
    const onClose = () => {
        setIsOpen(false);
        const myId = user?.id || user?._id;
        const targetRoom = RoomDetails?.room_id || roomId;
        if (!RoomDetails?.isGroupChat && targetRoom) {
            socketModel.emit('stop-video-call', {
                room_id: targetRoom,
                reason: "declined",
                user_id: myId,
                sender: myId,
            });
        }
        dispatch(video_modal(false));
    };
    useEffect(() => {
        setRoomDetails(chats?.find((_data) => String(_data?.room_id) === String(roomId)));
    }, [roomId, chats]);

    const onAccept = () => {
        socketModel.emit("accept-call", {
            room_id: roomId,
            call_type: "video",
        });
        setIsOpen(false);
        dispatch(video_modal(false));
        history(`/chat?room_idd=${roomId}&videoCall=true`);
    };

    return (
        <Transition appear show={isOpen} as={React.Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                {/* Backdrop */}
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 flex items-center justify-center p-4">
                    {/* Modal Panel */}
                    <Transition.Child
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <Dialog.Title
                                as="h3"
                                className="text-lg font-medium leading-6 text-gray-900"
                            >

                            </Dialog.Title>

                            {/* Video Preview */}
                            <div className="mt-4 text-center">
                                <img
                                    src={methodModel.userImg(CallingUserData?.user_image)}
                                    className="object-cover w-16 h-16 mb-2 m-auto rounded-full"
                                />
                            </div>

                            <div className="mt-4 text-center">
                                <p className="text-gray-500">{CallingUserData?.name}...</p>
                            </div>

                            {/* Buttons */}
                            <div className="mt-6 flex items-center justify-center gap-4">
                                <button
                                    className="flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-white hover:bg-green-600"
                                    onClick={onAccept}
                                >
                                    <FaVideo className="w-5 h-5" />
                                    Accept
                                </button>
                                <button
                                    className="flex items-center justify-center gap-2 rounded-full bg-red-500 px-6 py-3 text-white hover:bg-red-600"
                                    onClick={onClose}
                                >
                                    <FaTimes className="w-5 h-5" />
                                    Decline
                                </button>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>

    );
};
export default VideoCallRingModal